<div class="flxClmn dashboard-page" style="position: relative;"
     [ngStyle]="generatePdfInProcess && {'overflow' : 'hidden'}">
    <div class="page-title-container flxClmn-center" style="z-index: 45;">
        <div class="page-title-inner-container">
            <span class="page-title">Trends and Insights</span>
        </div>
		<div class="page-subtitle-container flxRow-between hSpace4">
            <span class="page-subtitle f-1-0">Outbound security trends, insights and recommended actions</span>
			<div class="flxRow hSpace1" style="background: var(--ui-warning-tint); border-radius: 999px; padding: 4px 12px; align-items: center;" *ngIf="trendsData?.created && !comparisonService.comparisonRunTriggered">
				<i class="far fa-clock" style="color: var(--ui-warning); font-size: 12px;"></i>
				<span style="color: var(--ui-warning); font-weight: 500;">Data updated as of {{trendsData.created | date: 'MM/dd/yyyy HH:mm'}}</span>
				<a class="blue-link" style="font-weight: 600;" (click)="getTrendsData(true);">Reload</a>
			</div>
        </div>
    </div>

    <div class="page-inner-content-holder bs-enabled" style="background: white; position: relative;"
         [ngClass]="{'no-scroll' : generatePdfInProcess}"
         [ngStyle]="{'overflow' : generatePdfInProcess ? 'hidden' : ''}">
        <!--generate pdf loader-->
        <div *ngIf="generatePdfInProcess" class="pdf-generate-loader">
            <div style=" position: absolute; top: calc(50vh - 200px - 40px); left: 50%; transform: translate(-50%,0); align-items: center;"
                 class="flxClmn vSpace2">
                <loader height="80" width="80" style="opacity: 0.8;"></loader>
                <span style="position: relative; font-size: 1rem; font-weight: 500; color: var(--ui-text-muted);" class="loading-dots">Generating PDF. Please wait</span>
            </div>
        </div>
        <!---->

        <div class="flxRow-between gap-2 mt-0 animated fadeIn" style="position: relative; z-index: 45; align-items: flex-start; margin: 20px 0; white-space: nowrap; flex-wrap: wrap;">
            <div class="flxRow gap-2 f-1-0" style="align-items: center; flex-wrap: wrap;">
                <div class="period-buttons-group bs-enabled flxRow gap-2">
                    <button class="period-button bs-btn bs-btn-light h-100"
                            *ngFor="let item of dashboardPeriod | keyvalue: gs.returnZero"
                            [ngClass]="{'chosen' : period === item.value, 'd-none' : item.value.display === dic.CONSTANTS.trendsPeriod.range.display, 'disabled': batchInProcess}"
                            (click)="changePeriod(item.value);">
                        {{item.value.display}}
                    </button>
                    <div class="position-relative range-button">
                        <button class="period-button gap-1 bs-btn bs-btn-light h-100" id="customPeriodBtn"
                                [ngClass]="{'chosen' : period.display === dic.CONSTANTS.trendsPeriod.range.display && !comparisonService.comparisonActive, 'disabled': batchInProcess}"
                                (click)="showTrendsCustomPeriod = !showTrendsCustomPeriod;">
                            <span *ngIf="period?.display === dic.CONSTANTS.trendsPeriod.range.display && !comparisonService.comparisonActive" style="font-weight: 300;">
                                From <b class="px-2">{{range.start | date:'MM/dd/yyyy'}}</b> Until <b class="px-2">{{range.end | date:'MM/dd/yyyy'}}</b>
                            </span>
                            <span *ngIf="period?.display !== dic.CONSTANTS.trendsPeriod.range.display || comparisonService.comparisonActive">
                                Custom
                            </span>
                            <i class="fas fa-sort-down" style="margin-top: -5px;"></i>
                        </button>
                        <!--custom period modal-->
                        <div class="drop-menu mt-1 p-2" style="width: fit-content; max-width: none; min-width: 300px; overflow: visible; min-height: 0;"
                             [ngClass]="{'active' : showTrendsCustomPeriod}">
                            <div class="p-3 text-start m-0 flex-row align-items-center gap-2" (clickOutside)="showTrendsCustomPeriod = false;"
                                 style="min-width: 490px;"
                                 [exclude]="'#customPeriodBtn'">
                                <div class="flxRow hSpace05 f-1-0" style="align-items: center;">
                                    <span>Date Range:</span>
                                    <date-picker-c class="f-1-0"
                                                   [(dateModel)]="range"
                                                   [isRange]="true"
                                                   [dateFormat]="'mm/dd/yyyy'">
                                    </date-picker-c>
                                </div>
                                <btn-c endIcon="zmdi zmdi-check"
                                     [loading]="getDataInProcess"
                                     (action)="changePeriod(dic.CONSTANTS.trendsPeriod.range);">
                                    Get Trends
                                </btn-c>
                            </div>
                        </div>
                    </div>
                    <div class="position-relative range-button">
                        <button class="period-button hSpace05 bs-btn bs-btn-light h-100" id="comparePeriodsBtn"
                                [ngClass]="{'chosen': comparisonService.comparisonActive, 'disabled': batchInProcess || comparisonService.comparisonLoading}"
                                (click)="openComparePicker();">
                            <span *ngIf="comparisonService.comparisonActive" style="font-weight: 300;">
                                <b class="px-2">{{comparisonService.currentPeriodDate | date: (comparisonService.granularity === 'monthly' ? 'MM/yyyy' : 'MM/dd/yy')}}</b>
                                <i class="far fa-exchange-alt"></i>
                                <b class="px-2">{{comparisonService.comparedPeriodDate | date: (comparisonService.granularity === 'monthly' ? 'MM/yyyy' : 'MM/dd/yy')}}</b>
                            </span>
                            <span *ngIf="!comparisonService.comparisonActive">Compare</span>
                            <i class="fas fa-sort-down" style="margin-top: -5px;"></i>
                        </button>
                        <div class="drop-menu mt-1 p-2" style="width: fit-content; max-width: none; overflow: visible; min-height: 0; right: -300px; left: auto;"
                             [ngClass]="{'active': showComparePicker}">
                            <div class="p-2" (clickOutside)="showComparePicker = false;" [exclude]="'#comparePeriodsBtn'">
                                <period-comparison-picker-c (onConfirm)="showComparePicker = false"></period-comparison-picker-c>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flxRow gap-1" style="align-items: center; flex-shrink: 0;">
                    <span style="margin-left: auto;" *ngIf="totalEmails && !comparisonService.comparisonActive">
                        <b style="font-size: 14px;">
                            Total Records: {{totalEmails}}
                        </b>
                        <i style="font-weight: 400; top: -4px; position: relative;" class="far fa-question-circle opacity-75"
                           tooltip='The trends report presented below has been generated based on this total number of sent emails'></i>
                    </span>
                    <div class="flxRow hSpace1" style="align-items: center; flex-shrink: 0; background: var(--ui-surface-2); border-radius: 999px; padding: 3px 6px 3px 12px;" *ngIf="(batchInProcess && outboundEmails?.length) || comparisonService.comparisonLoading">
                    	<i class="far fa-spin fa-spinner" style="color: var(--ui-brand); font-size: 12px;"></i>
                    	<span style="font-weight: 500; color: var(--ui-text-muted); white-space: nowrap;">Processing</span>
                    	<span style="font-weight: 600; color: var(--ui-text); min-width: 34px;">{{comparisonService.comparisonLoading && comparisonService.comparisonProgressPercent ? comparisonService.comparisonProgressPercent : getPercentage(outboundEmails.length, totalEmails)}}%</span>
                    	<div style="width: 80px; height: 4px; border-radius: 999px; background: var(--ui-border); overflow: hidden;">
                    		<div style="height: 100%; border-radius: 999px; background: var(--ui-brand); transition: width 0.3s;" [style.width.%]="comparisonService.comparisonLoading && comparisonService.comparisonProgressPercent ? comparisonService.comparisonProgressPercent : getPercentage(outboundEmails.length, totalEmails)"></div>
                    	</div>
                        <btn-c variant="text" color="danger"
                               style="min-width: 0;"
                               *ngIf="showAbortLoadingEmailsLabel || comparisonService.comparisonActive"
                               (action)="comparisonService.comparisonActive ? comparisonService.abortComparisonBatches() : abortLoadingEmails();">
                            Abort
                        </btn-c>
                    </div>
                </div>
            </div>

            <div class="flxRow gap-1" style="flex-direction: row-reverse; flex-wrap: wrap; align-items: flex-start;">
                <btn-c endIcon="far fa-file-download" variant="outlined"
                     [isDisabled]="!trendsData || generatePdfInProcess || getTrendsDataInProcess || batchInProcess"
                     (action)="exportChartsToPdf();">
                    Export to PDF
                </btn-c>
            </div>
        </div>

        <div class="bs-enabled" id="trendsChartsContainer"
             [appTrendsComparison]="{host: this, componentClass: selfComponentClass}">
            <div class="bs-container outbound-trends-cards text-center" style="max-width: none !important;"
                 [ngClass]="{'w-100' : !generatePdfInProcess}">
				<div class="bs-row trends-pdf-page-title" style="display: none;">
					<img class="mb-3" [src]="lfs.logo" style="width: 200px;"/>
				</div>
                <div class="bs-row trends-pdf-page-title" style="display: none;">
                    <div class="bs-col-12 mb-4 px-4" style="background: #fdfdfd; padding: 10px;">
                        <div class="flxClmn vSpace05">
                            <div class="flxRow-between" style="align-items: flex-end;">
                                <span style="font-weight: bold; font-size: 1.6rem; white-space: nowrap;">Outbound Trends and Insights</span>
                                <span style="font-size: 1.25rem; white-space: nowrap;">
                                Date printed: &nbsp;
                                <time>{{todayDate | date:'MM/dd/yyyy'}}</time>
                            </span>
                            </div>
                            <div class="flxRow hSpace05" style="font-size: 1.25rem;">
                                <span>Period:&nbsp;</span>
                                <span *ngIf="period !== dic.CONSTANTS.trendsPeriod.range" style="white-space: nowrap;">{{period.display}}</span>
                                <span *ngIf="period === dic.CONSTANTS.trendsPeriod.range" style="white-space: nowrap;">
							<time>{{range.start | date:'MM/dd/yyyy'}}</time>
							&nbsp;-&nbsp;
							<time>{{range.end | date:'MM/dd/yyyy'}}
							</time>
						</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bs-row g-4">
                    <!--Outbound Trends-->
                    <div class="bs-col-6 bs-col-large-4" style="height: clamp(350px,50vh,405px);"
                         [appTrendsComparisonCard]="{key: 'outboundEmailsChartOptions', chartRefKey: 'outboundEmailsChart'}">
                        <div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
                            <div class="flex-column align-items-start gap-1">
                                <div class="flex-row align-items-center gap-1">
                                    <h6 class="m-0 fw-bold text-nowrap">Outbound Trends</h6>
                                    <i style="font-weight: 400; top: -4px; position: relative;" class="far fa-question-circle opacity-75"
                                       tooltip='Shows how many secure emails (which use "Encrypt Message Content" and/or "Require Authentication") were sent in selected time period out of the total emails sent using Trustifi'></i>
									<div class="loading-spinner trends-card-spinner" *ngIf="batchInProcess && !getTrendsDataInProcess"></div>
								</div>
                                <span class="opacity-75 fw-500 text-start" style="height: 16px;">{{trendsData?.general?.total}} emails sent in the {{period.display.toLowerCase()}}</span>
                            </div>
							<apx-chart style="width: 100%;"
									   *ngIf="outboundEmailsChartOptions && trendsData?.general?.total && !getTrendsDataInProcess"
									   #outboundEmailsChart
									   class="f-1-0 animated fadeIn clickable-chart"
									   [series]="outboundEmailsChartOptions.series"
									   [plotOptions]="outboundEmailsChartOptions.plotOptions"
									   [chart]="outboundEmailsChartOptions.chart"
									   [dataLabels]="outboundEmailsChartOptions.dataLabels"
									   [colors]="outboundEmailsChartOptions.colors"
									   [xaxis]="outboundEmailsChartOptions.xaxis"
									   [yaxis]="outboundEmailsChartOptions.yaxis"
									   [fill]="outboundEmailsChartOptions.fill"
									   [stroke]="outboundEmailsChartOptions.stroke">
							</apx-chart>
                            <trends-comparison-chart></trends-comparison-chart>
                            <!--loader / placeholder-->
                            <div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!trendsData?.general?.total || getTrendsDataInProcess">
                                <div class="flex-column text-center centralize f-1-0">
                                    <span class="fw-500 opacity-75" *ngIf="!getTrendsDataInProcess">No data for selected time period</span>
                                    <loader class="opacity-75 align-self-center" *ngIf="getTrendsDataInProcess" height="100" width="100"></loader>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Outbound rules usage-->
                    <div class="bs-col-6 bs-col-large-4" style="height: clamp(350px,50vh,405px);"
                         [appTrendsComparisonCard]="{key: 'outboundRulesChartOptions', chartRefKey: 'outboundRulesChart'}">
                        <div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
                            <div class="flex-row justify-content-between">
                                <div class="flex-column align-items-start gap-1">
                                    <div class="flex-row align-items-center gap-1">
                                        <h6 class="m-0 fw-bold">Outbound Rules Usage</h6>
										<div class="loading-spinner trends-card-spinner" *ngIf="batchInProcess && !getTrendsDataInProcess"></div>
									</div>
                                    <span *ngIf="!getTrendsDataInProcess && trendsData?.rules?.total" class="opacity-75 fw-500 text-start" style="height: 16px;">{{trendsData.rules.total}} emails caught by outbound rules in the {{period.display.toLowerCase()}}</span>
                                </div>
                            </div>
                            <div class="flex-column f-1-0 centralize animated fadeIn position-relative"
                                 *ngIf="outboundRulesChartOptions?.labels?.length && !getTrendsDataInProcess">
								<apx-chart style="width: 100%;"
										   #outboundRulesChart
										   class="pie-chart clickable-chart"
										   [series]="outboundRulesChartOptions.series"
										   [plotOptions]="outboundRulesChartOptions.plotOptions"
										   [chart]="outboundRulesChartOptions.chart"
										   [dataLabels]="outboundRulesChartOptions.dataLabels"
										   [labels]="outboundRulesChartOptions.labels">
								</apx-chart>
                            </div>
                            <trends-comparison-chart></trends-comparison-chart>
                            <!--actions menu-->
                            <div class="trends-card-actions-menu" (ngInit)="showOutboundRulesMenu = false;">
                                <i class="fas fa-ellipsis-h" id="outboundRulesMenuTrigger" tooltip="Menu"
                                   (click)="showOutboundRulesMenu = !showOutboundRulesMenu"></i>
                                <div class="drop-menu" [ngClass]="{'active' : showOutboundRulesMenu}">
                                    <ul (clickOutside)="showOutboundRulesMenu = false;"
                                        [exclude]="'#outboundRulesMenuTrigger'">
                                        <li class="flex-row align-items-center"
                                            [routerLink]="['/' + dic.CONSTANTS.appStates.adminOutbound, dic.CONSTANTS.adminPages.outbound.policyManagement, dic.CONSTANTS.outboundRulesAndPoliciesPageTabs.rules]">
                                            <span>Go to Outbound Rules</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <!--tips modal-->
                            <div class="trends-card-actions-menu tips"
                                 *ngIf="outboundRulesChartOptions"
                                 [ngClass]="{'active' : showOutboundRulesTips}">
                                <i class="far fa-lightbulb" id="outboundRulesTipsTrigger" tooltip="Tips"
                                   (click)="showOutboundRulesTips = !showOutboundRulesTips"></i>
                                <div class="drop-menu mt-1" style="width: fit-content; max-width: none; min-width: 300px; background: linear-gradient(90deg, hsla(var(--bs-primary-h), calc(var(--bs-primary-s) + 30%), var(--bs-primary-l),0.1), white) , linear-gradient(45deg, white, white);"
                                     [ngClass]="{'active' : showOutboundRulesTips}">
                                    <ul style="cursor: default;" (clickOutside)="showOutboundRulesTips = false;"
                                        [exclude]="'#outboundRulesTipsTrigger'" >
                                        <div class="py-3 px-3 text-start m-0 flex-row align-items-center gap-2">
                                            <i class="far fa-hand-pointer fw-500" style="flex: 0 0 16px;"></i>
                                            <span class="fw-500">Click on any pie slice to view the usage of the rule.</span>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                            <!--loader / placeholder-->
                            <div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!outboundRulesChartOptions?.labels?.length || getTrendsDataInProcess">
                                <div class="flex-column text-center centralize f-1-0">
                                    <span class="fw-500 opacity-75" *ngIf="!getTrendsDataInProcess">No data for selected time period</span>
                                    <loader class="opacity-75 align-self-center" *ngIf="getTrendsDataInProcess" height="100" width="100"></loader>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Email Events Rate-->
                    <div class="bs-col-6 bs-col-large-4" style="height: clamp(350px,50vh,405px);"
                         [appTrendsComparisonCard]="{key: 'eventRateChartOptions', chartRefKey: 'eventRateChart'}">
                        <div class="trends-data-card flex-column gap-1 p-3 animated fadeIn h-100 w-100">
                            <div class="flex-row justify-content-between">
                                <div class="flex-column align-items-start gap-1">
                                    <div class="flex-row align-items-center gap-1">
                                        <h6 class="m-0 fw-bold">Deliverability to Recipients</h6>
										<div class="loading-spinner trends-card-spinner" *ngIf="batchInProcess && !getTrendsDataInProcess"></div>
									</div>
                                    <span class="opacity-75 fw-500 text-start">Displays the percentage of emails opened, bounced and complaints out of the total email recipients in the {{period.display.toLowerCase()}}</span>
                                </div>
                            </div>

                            <div class="flex-column f-1-0 centralize animated fadeIn"
                                 *ngIf="eventRateChartOptions && trendsData?.general?.total && !getTrendsDataInProcess">
								<apx-chart style="flex: 1 0; width: 100%; max-width: 700px;"
										   #eventRateChart
										   class="trends-radial-pie-chart"
										   [series]="eventRateChartOptions.series"
										   [plotOptions]="eventRateChartOptions.plotOptions"
										   [chart]="eventRateChartOptions.chart"
										   [colors]="eventRateChartOptions.colors"
										   [legend]="eventRateChartOptions.legend"
										   [labels]="eventRateChartOptions.labels">
								</apx-chart>
                            </div>
                            <trends-comparison-chart></trends-comparison-chart>
                            <!--loader / placeholder-->
                            <div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!trendsData?.general?.total || getTrendsDataInProcess">
                                <div class="flex-column text-center centralize f-1-0">
                                    <span class="fw-500 opacity-75" *ngIf="!getTrendsDataInProcess">No data for selected time period</span>
                                    <loader class="opacity-75 align-self-center" *ngIf="getTrendsDataInProcess" height="100" width="100"></loader>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="bs-col-4 mt-4 bs-container large-only" [ngStyle]="{'display' : generatePdfInProcess || comparisonService.comparisonRunTriggered ? 'contents' : ''}">
                        <div class="bs-row bs-row-cols-1 g-4 large-only" style="gap: 3px;" [ngStyle]="{'display' : generatePdfInProcess || comparisonService.comparisonRunTriggered ? 'contents' : ''}">
                            <!--Top Senders Domains-->
                            <div class="bs-col-6 bs-col-large-12" style="height: clamp(350px,50vh,405px);"
                                 [appTrendsComparisonCard]="{key: 'topSendersChartOptions', chartRefKey: 'topSendersChart'}">
                                <div class="trends-data-card flex-column p-3 animated fadeIn h-100 w-100">
                                    <div class="flex-column align-items-start gap-1">
                                        <div class="flex-row align-items-center gap-1">
                                            <h6 class="m-0 fw-bold text-nowrap">Top Senders</h6>
                                            <i style="font-weight: 400; top: -4px; position: relative;" class="far fa-question-circle opacity-75"
                                               tooltip="Displays the top 10 users within your organization who send the highest number of emails."></i>
											<div class="loading-spinner trends-card-spinner" *ngIf="batchInProcess && !getTrendsDataInProcess"></div>
										</div>
                                    </div>
									<apx-chart class="f-1-0 w-100 animated fadeIn"
											   *ngIf="topSendersChartOptions?.xaxis?.categories?.length && !getTrendsDataInProcess"
											   #topSendersChart
											   [series]="topSendersChartOptions.series"
											   [plotOptions]="topSendersChartOptions.plotOptions"
											   [chart]="topSendersChartOptions.chart"
											   [colors]="topSendersChartOptions.colors"
											   [dataLabels]="topSendersChartOptions.dataLabels"
											   [xaxis]="topSendersChartOptions.xaxis">
									</apx-chart>
                                    <trends-comparison-chart></trends-comparison-chart>
                                    <!--actions menu-->
                                    <div class="trends-card-actions-menu">
                                        <i class="fas fa-ellipsis-h" id="topSenderMenuTrigger" tooltip="Menu"
                                           (click)="showTopSenderMenu = !showTopSenderMenu"></i>
                                        <div class="drop-menu" [ngClass]="{'active' : showTopSenderMenu}">
                                            <ul (clickOutside)="showTopSenderMenu = false;"
                                                [exclude]="'#topSenderMenuTrigger'">
                                                <li class="flex-row align-items-center"
                                                    (click)="exportSendersToCsv();">
                                                    <span>Export to CSV</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <!--loader / placeholder-->
                                    <div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!topSendersChartOptions?.xaxis?.categories?.length || getTrendsDataInProcess">
                                        <div class="flex-column text-center centralize f-1-0">
                                            <span class="fw-500 opacity-75" *ngIf="!getTrendsDataInProcess">No data for selected time period</span>
                                            <loader class="opacity-75 align-self-center" *ngIf="getTrendsDataInProcess" height="100" width="100"></loader>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--Top Recipients Domains-->
                            <div class="bs-col-6 bs-col-large-12" style="min-height: clamp(350px,50vh,405px);"
                                 [appTrendsComparisonCard]="{key: 'topRecipientsDomainsChartOptions', chartRefKey: 'topRecipientsDomainsChart'}">
                                <div class="trends-data-card flex-column gap-1 p-3 animated fadeIn h-100 w-100">
                                    <div class="flex-row justify-content-between">
                                        <div class="flex-column align-items-start gap-1">
                                            <div class="flex-row align-items-center gap-1">
                                                <h6 class="m-0 fw-bold">Top External Recipient Domains</h6>
                                                <i style="font-weight: 400; top: -4px; position: relative;" class="far fa-question-circle opacity-75"
                                                   tooltip="Displays the top 10 external recipient domains that receive the highest number of emails from your organization."></i>
												<div class="loading-spinner trends-card-spinner" *ngIf="batchInProcess && !getTrendsDataInProcess"></div>
											</div>
                                        </div>
                                    </div>

									<apx-chart class="f-1-0 animated fadeIn"
											   *ngIf="topRecipientsDomainsChartOptions?.xaxis?.categories?.length && !getTrendsDataInProcess"
											   #topRecipientsDomainsChart
											   [series]="topRecipientsDomainsChartOptions.series"
											   [plotOptions]="topRecipientsDomainsChartOptions.plotOptions"
											   [chart]="topRecipientsDomainsChartOptions.chart"
											   [colors]="topRecipientsDomainsChartOptions.colors"
											   [dataLabels]="topRecipientsDomainsChartOptions.dataLabels"
											   [xaxis]="topRecipientsDomainsChartOptions.xaxis">
									</apx-chart>
                                    <trends-comparison-chart></trends-comparison-chart>
                                    <!--actions menu-->
                                    <div class="trends-card-actions-menu">
                                        <i class="fas fa-ellipsis-h" id="topRecipientsMenuTrigger" tooltip="Menu"
                                           (click)="showTopRecipientsMenu = !showTopRecipientsMenu"></i>
                                        <div class="drop-menu" [ngClass]="{'active' : showTopRecipientsMenu}">
                                            <ul (clickOutside)="showTopRecipientsMenu = false;"
                                                [exclude]="'#topRecipientsMenuTrigger'">
                                                <li class="flex-row align-items-center"
                                                    (click)="exportRecipientsToCsv();">
                                                    <span>Export to CSV</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <!--loader / placeholder-->
                                    <div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!topRecipientsDomainsChartOptions?.xaxis?.categories?.length || getTrendsDataInProcess">
                                        <div class="flex-column text-center centralize f-1-0">
                                            <span class="fw-500 opacity-75" *ngIf="!getTrendsDataInProcess">No data for selected time period</span>
                                            <loader class="opacity-75 align-self-center" *ngIf="getTrendsDataInProcess" height="100" width="100"></loader>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Connections Graph-->
                    <div class="bs-col-6 bs-col-large-8 connections-graph-card" [ngStyle]="{'height' : generatePdfInProcess ? '650px' : ''}"
                         *ngIf="!comparisonService.comparisonRunTriggered">
                        <div class="trends-data-card flex-column gap-3 p-3 animated fadeIn h-100 w-100">
                            <div class="flex-row align-items-center justify-content-between gap-2">
                                <h6 class="m-0 fw-bold">Connections Graph</h6>
                                <div class="period-buttons-group bs-enabled flex-row gap-2 align-items-center animated fadeIn pdf-excluded" style="margin-right: 32px;">
                                    <button class="period-button px-2 flex-row gap-2 bs-btn bs-btn-light text-capitalize"
                                            *ngFor="let view of connectionsGraphViews | keyvalue: gs.returnZero"
                                            [ngClass]="{'chosen' : view.value === connectionsGraphView}"
                                            (click)="setConnectionsGraphView(view.value);">
										<i [ngClass]="{'fa': true, 'fa-user-tie' : view.value === connectionsGraphViews.top, 'fa-users' : view.value === connectionsGraphViews.all}"></i>
                                        <span class="w-100 text-center">{{view.value}}</span>
                                    </button>
                                </div>
                            </div>
                            <div class="opacity-75 fw-500 text-start">
                                Visualizes the connections between <b style="color: green;">senders</b> in your organization and the <b style="color: darkblue;">recipient domains</b> of their emails.
                            </div>

							<echarts-graph class="flxClmn f-1-0"
											  *ngIf="!batchInProcess && !getTrendsDataInProcess && !connectionsGraphLoading"
											  #connectionsGraphEl
											  [showLegend]="true"
											  [nodeCfg]="graphNodeCfg"
											  [nodeOptionsFn]="connectionsGraphData?.nodeOptionsFn"
											  [focusedNodesNames]="connectionsGraphData?.nodeSearchResults"
											  [rawGraphData]="connectionsGraphData?.graphData"></echarts-graph>

                            <!--actions menu-->
                            <div class="trends-card-actions-menu">
                                <i class="fas fa-ellipsis-h" id="connectionsGraphMenuTrigger" tooltip="Menu"
                                   (click)="showConnectionsGraphMenu = !showConnectionsGraphMenu"></i>
                                <div class="drop-menu" [ngClass]="{'active' : showConnectionsGraphMenu}">
                                    <ul (clickOutside)="showConnectionsGraphMenu = false;"
                                        [exclude]="'#connectionsGraphMenuTrigger'">
                                        <li class="flex-row align-items-center"
                                            (click)="goToReportsPage();">
                                            <span>Configure reports</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <!--loader / placeholder-->
                            <div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!trendsData?.general?.total || getTrendsDataInProcess || batchInProcess || connectionsGraphLoading">
                                <div class="flex-column text-center centralize f-1-0">
                                    <span class="fw-500 opacity-75" *ngIf="!getTrendsDataInProcess && !batchInProcess && !connectionsGraphLoading">No data for selected time period</span>
                                    <loader class="opacity-75 align-self-center" *ngIf="getTrendsDataInProcess || batchInProcess || connectionsGraphLoading" height="100" width="100"></loader>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--rule usage popup-->
    <outbound-rule-usage-c
            *ngIf="ruleUsagePopupData && ruleUsagePopupData?.show"
            [data]="ruleUsagePopupData">
    </outbound-rule-usage-c>
</div>
